
import { render } from 'react-isomorphic-render';
import 'regenerator-runtime'; // eslint-disable-line import/no-extraneous-dependencies
import settings from '../app/react-isomorphic-render';

if (process.env.NODE_ENV !== 'production') {
  import('source-map-support/register');
}

// Client Side Hookup
(async function() {
  await render(settings, {}).then(({ store, rerender }) => {
    if (module.hot) {
      module.hot.accept('../app/react-isomorphic-render', () => {
        store.hotReload(settings.reducer);
        rerender();
      });
    }
  });
}());



// WEBPACK FOOTER //
// ./client/index.js